import { render, staticRenderFns } from "./contentUserRestore.vue?vue&type=template&id=6dd4da42&"
import script from "./contentUserRestore.vue?vue&type=script&lang=js&"
export * from "./contentUserRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports